import React from 'react';

export default function Voorwaarden() {
  return (
    <>
      {/* Page Hero */}
      <section className="bg-[#2d5e5e] pt-32 pb-16 text-center text-white">
        <div className="max-w-6xl mx-auto px-5">
          <h1 className="text-3xl font-bold mb-3">Algemene Voorwaarden</h1>
          <p className="text-lg opacity-90">PUUR Psychiatrie B.V.</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-24 bg-white">
        <div className="max-w-3xl mx-auto px-5">
          <article className="mb-10 pb-10 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-[#2d5e5e] mb-4">Artikel 1 - Definities</h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              In deze algemene voorwaarden wordt verstaan onder:
            </p>
            <p className="text-gray-700 leading-relaxed mb-3">
              <strong>PUUR Psychiatrie:</strong> PUUR Psychiatrie B.V., gevestigd te Nederland, ingeschreven bij de Kamer van Koophandel onder nummer 88552489.
            </p>
            <p className="text-gray-700 leading-relaxed">
              <strong>Opdrachtgever:</strong> De GGZ-instelling of organisatie die een overeenkomst aangaat met PUUR Psychiatrie voor het leveren van psychiatrische diensten.
            </p>
          </article>

          <article className="mb-10 pb-10 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-[#2d5e5e] mb-4">Artikel 2 - Toepasselijkheid</h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              Deze algemene voorwaarden zijn van toepassing op alle aanbiedingen, offertes en overeenkomsten tussen PUUR Psychiatrie en de Opdrachtgever.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Afwijkingen van deze voorwaarden zijn slechts geldig indien deze uitdrukkelijk schriftelijk zijn overeengekomen.
            </p>
          </article>

          <article className="mb-10 pb-10 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-[#2d5e5e] mb-4">Artikel 3 - Strippenkaartmodel</h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              PUUR Psychiatrie werkt met een strippenkaartmodel waarbij uren worden ingekocht voor een afgesproken periode.
            </p>
            <p className="text-gray-700 leading-relaxed mb-3">
              Het uurtarief bedraagt € 190,- exclusief BTW. Medische handelingen zijn vrijgesteld van BTW.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Niet-gebruikte uren binnen de afgesproken periode zijn overdraagbaar naar de volgende periode, mits een vervolgovereenkomst wordt aangegaan.
            </p>
          </article>

          <article className="mb-10 pb-10 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-[#2d5e5e] mb-4">Artikel 4 - Facturatie en betaling</h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              Facturatie vindt plaats bij aanvang van de overeengekomen periode of per maand, afhankelijk van de gemaakte afspraken.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Betaling dient te geschieden binnen 30 dagen na factuurdatum, tenzij schriftelijk anders overeengekomen.
            </p>
          </article>

          <article className="mb-10 pb-10 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-[#2d5e5e] mb-4">Artikel 5 - Uitvoering diensten</h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              PUUR Psychiatrie zal de overeengekomen diensten naar beste inzicht en vermogen uitvoeren, conform de geldende professionele standaarden.
            </p>
            <p className="text-gray-700 leading-relaxed">
              De psychiater van PUUR Psychiatrie is BIG-geregistreerd en handelt conform de richtlijnen van de beroepsgroep.
            </p>
          </article>

          <article className="mb-10 pb-10 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-[#2d5e5e] mb-4">Artikel 6 - Geheimhouding</h2>
            <p className="text-gray-700 leading-relaxed">
              Beide partijen zijn verplicht tot geheimhouding van alle vertrouwelijke informatie die zij in het kader van de overeenkomst van elkaar hebben ontvangen. Patiëntgegevens worden verwerkt conform de AVG en de Wet op de geneeskundige behandelingsovereenkomst (WGBO).
            </p>
          </article>

          <article className="mb-10 pb-10 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-[#2d5e5e] mb-4">Artikel 7 - Annulering</h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              Annulering van ingeplande werkzaamheden dient minimaal 48 uur van tevoren te geschieden.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Bij annulering binnen 48 uur kunnen de gereserveerde uren in rekening worden gebracht.
            </p>
          </article>

          <article className="mb-10 pb-10 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-[#2d5e5e] mb-4">Artikel 8 - Aansprakelijkheid</h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              PUUR Psychiatrie is verzekerd voor beroepsaansprakelijkheid conform de eisen van de beroepsgroep.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Aansprakelijkheid is beperkt tot het bedrag dat in het desbetreffende geval door de verzekeraar wordt uitgekeerd.
            </p>
          </article>

          <article>
            <h2 className="text-xl font-semibold text-[#2d5e5e] mb-4">Artikel 9 - Toepasselijk recht</h2>
            <p className="text-gray-700 leading-relaxed">
              Op alle overeenkomsten tussen PUUR Psychiatrie en de Opdrachtgever is Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter in het arrondissement waar PUUR Psychiatrie is gevestigd.
            </p>
          </article>
        </div>
      </section>
    </>
  );
}
